export const DEFAULT_LANGUAGE = "en";
export const SUPPORTED_LANGUAGES = [
  "en",
  "es",
  "fr",
  "it",
  "de",
  "zh",
  "ko",
] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LOCALE_COOKIE_NAME = "NEXT_LOCALE";

/**
 * Maps BCP-47 locale codes (stored in user preferences DB) to short language
 * codes used by the portal's LanguageContext / NEXT_LOCALE cookie.
 */
export const BCP47_TO_SHORT: Record<string, SupportedLanguage> = {
  "en-US": "en",
  "es-US": "es",
  "zh-CN": "zh",
  "ko-KR": "ko",
};

/** Maps short portal language codes to BCP-47 locale codes for the DB. */
export const SHORT_TO_BCP47: Record<string, string> = {
  en: "en-US",
  es: "es-US",
  zh: "zh-CN",
  ko: "ko-KR",
};
